import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import {
  createGenerateClassName,
  createTheme,
  jssPreset,
  StylesProvider,
  ThemeProvider
} from "@material-ui/core/styles";
import { create } from 'jss';

import LoanApplication from './components/LoanApplication';
import LoanOptions from './components/LoanOptions';
import LoanCards from './components/LoanCards';

import useContext, { disableUrlSync as disableContextUrlSync, enableUrlSync } from './context';


const theme = createTheme({
  palette: {
    primary: {
      main: '#1969B9'
    }
  }
});

const getStylesContext = (node) => {
  const doc = node && node.ownerDocument;

  if (!doc || !doc.head) {
    return null;
  }

  if (doc.mofQuoteCalculatorStylesContext) {
    return doc.mofQuoteCalculatorStylesContext;
  }

  const insertionPoint = doc.createComment('mof-quote-calculator-jss-insertion-point');
  doc.head.insertBefore(insertionPoint, doc.head.firstChild);

  doc.mofQuoteCalculatorStylesContext = {
    generateClassName: createGenerateClassName({
      productionPrefix: 'mof'
    }),
    jss: create({
      plugins: jssPreset().plugins,
      insertionPoint
    }),
    sheetsManager: new Map()
  };

  return doc.mofQuoteCalculatorStylesContext;
};

/**
 * React component that displays either the loan options page or the loan application page
 */
export default function QuoteCalculator({ disableUrlSync = false }) {
  const [context] = useContext();
  const rootRef = useRef(null);
  const [stylesContext, setStylesContext] = useState(null);

  useEffect(() => {
    if (!disableUrlSync) {
      return undefined;
    }

    disableContextUrlSync();

    return () => enableUrlSync();
  }, [disableUrlSync]);

  useLayoutEffect(() => {
    const nextStylesContext = getStylesContext(rootRef.current);

    if (nextStylesContext) {
      setStylesContext(nextStylesContext);
    }
  }, []);

  const calculator = (
    <ThemeProvider theme={theme}>
      <div className={`quoteform ${context.active ? 'quoteform--active' : ''}`}>
        {
          context.loanOption
            ? <LoanApplication />
            : <React.Fragment>
                <LoanOptions />
                <LoanCards />
              </React.Fragment>
        }
      </div>
    </ThemeProvider>
  );

  return (
    <div ref={rootRef}>
      {stylesContext
        ? (
          <StylesProvider
            generateClassName={stylesContext.generateClassName}
            jss={stylesContext.jss}
            sheetsManager={stylesContext.sheetsManager}
          >
            {calculator}
          </StylesProvider>
        )
        : null}
    </div>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/QuoteCalculator.js